"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.795 4.652a3.426 3.426 0 0 1 4.834 0l1.226 1.22a3.426 3.426 0 0 1 0 4.855l-4.237 4.219H16.3a.7.7 0 1 1 0 1.4H7.28a2.88 2.88 0 0 1-2.033-.84l-1.239-1.233a3.426 3.426 0 0 1 0-4.854zm-.161 10.294 1.077-1.073-4.095-4.079-.62.617a2.026 2.026 0 0 0 0 2.87l1.239 1.233a1.48 1.48 0 0 0 1.044.432zm-2.026-6.14 4.095 4.079 3.164-3.15a2.026 2.026 0 0 0 0-2.87l-1.226-1.22a2.026 2.026 0 0 0-2.858 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EraserIcon20.js.map